import React from 'react'
import {NavLink} from 'react-router-dom';
import { MicrophoneIcon, UserFollowIcon} from 'components/vectors';


const LandingPage = () => (
    <div className="landing-page">
        <div className="landing-page__content">
            <div className="w-100">
                <h2 className="text--md-light text-center text--black landing-page__header">Welcome to Music & Rights </h2>
            </div>
            
            <div className="w-100">
                <div className="col-md-6 mx-auto">
                    <div className="landing-option">
                        <MicrophoneIcon />
                        <div className="landing-option__content">
                            <h5 className="text--md-light text--black">Search for Artist</h5>
                            <p className="text--small text--grey text-left">Discover more interesting information about artist.Try now by clicking this<NavLink to="/" className="auth__link"> Kanye West?</NavLink> </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100">
                <div className="col-md-6 mx-auto">
                    <div className="landing-option">
                        <UserFollowIcon />
                        <div className="landing-option__content">
                            <h5 className="text--md-light text--black">Follow an Artist</h5>
                            <p className="text--small text--grey text-left">Follow any artist for more update by clicking on the button on the artist profile</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default LandingPage;